import { useEffect, useState, useRef } from "react";
import "./toast-dialog-style.css";

const ToastDialog = ({ open, onClose, message = "" }) => {
  const [leaving, setLeaving] = useState(false);
  const closeTimerRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    const timer = setTimeout(() => {
      requestClose();
    }, 1000);

    return () => clearTimeout(timer);
  }, [open, onClose]);

  const requestClose = () => {
    if (leaving) return;
    setLeaving(true);

    closeTimerRef.current = setTimeout(() => {
      onClose?.();
      setLeaving(false); // 下次打開重置
    }, 180); // 要跟 toastOut 時間一致
  };

  if (!open) return null;

  return (
    <div className="toast-backdrop" onMouseDown={onClose}>
      <div
        className={`toast-dialog ${leaving ? "leave" : "enter"}`}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <img src={`/images/ic-yellow-ok.png`} loading="lazy"></img>
        <span>{message}</span>
      </div>
    </div>
  );
};

export default ToastDialog;
